import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class ErrorPageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
